import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { renameWorkstream } from './client';
import { keys } from './keys';

/**
 * Rename a workstream — the mutation behind the rail's Rename dialog.
 * `mutate(title)` calls `PATCH /workstreams/{id}`; on settle it invalidates
 * `keys.workstream.listMine()` so the rail card AND the conversation header
 * (both read the title from that list) pick up the new name. Pending-UI +
 * invalidate rather than an optimistic cache edit (frontend-architecture R7):
 * the dialog stays open until the server confirms, so there is nothing to roll
 * back. Consumers disable Save on `isPending` (the double-submit guard).
 */
export function useRenameWorkstream(workstreamId: string) {
  const { getAccessToken } = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: keys.workstream.renameWorkstream(workstreamId),
    mutationFn: (title: string) => renameWorkstream(workstreamId, { title }, { getAccessToken }),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: keys.workstream.listMine() });
    },
  });
}
